import {
    TextField,
    Typography,
    Grid,
    CircularProgress,
    FormControl,
    FormControlLabel,
    RadioGroup,
    Radio,
    Slider,
    Button,
    IconButton} from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowRight } from "@material-ui/icons";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { ReactElement } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { globalStyles } from "../../../assets/globalStyles";
import { analyseAnfrage } from "../../../utils/apiTypes";
import {
    selectIsListeLoading, selectKenngroesseListe, selectKorrelationZwischenTemp, selectKorrelationZwischenWertTemp, selectMessstelleListe,
    selectopenGroups, setOpenGroups,
    selectSliderTemp, 
    setIsChangedKorrelation, setKorrelationZwischenTemp, setKorrelationZwischenWertTemp, setSliderTemp, 
    selectCalculatedKorrelationenList, selectLoadingCalculatedKorrelationen, selectselectedCalculatedKorrelation, setSelectedCalculatedKorrelation, setErgebnistyp, selectErgebnistyp, getCalculatedKorrelationen
} from "./korrelationFilterSlice";
import { useStyles } from "./korrelationStyle";
import { CorrelationCalculationType, CorrelationResultType, marksObject } from "./korrelationTypes";
import CachedIcon from '@material-ui/icons/Cached';
import { round4Digits } from "../../../utils/utils";

export default function KorrelationFilter(): ReactElement {
    const dispatch = useAppDispatch();
    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const calculatedKorrelationen = useAppSelector(selectCalculatedKorrelationenList);
    const isCalculatedKorrelationenLoading = useAppSelector(selectLoadingCalculatedKorrelationen);
    const selectedCalculatedKorrelation = useAppSelector(selectselectedCalculatedKorrelation);
    const isListeLoading = useAppSelector(selectIsListeLoading);
    const kenngroesseListe = useAppSelector(selectKenngroesseListe);
    const messstelleListe = useAppSelector(selectMessstelleListe);
    const korrelationZwischenTemp = useAppSelector(selectKorrelationZwischenTemp);
    const korrelationZwischenWertTemp = useAppSelector(selectKorrelationZwischenWertTemp);
    const sliderTemp = useAppSelector(selectSliderTemp);
    const ergebnistyp = useAppSelector(selectErgebnistyp);

    const openGroups = useAppSelector(selectopenGroups);

    const [calculatedKorrelationenInputvalue, setCalculatedKorrelationenInputvalue] = React.useState('');

    const marks = fillMarks();
    function fillMarks(): Array<marksObject> {
        const marks = [];
        let mark = -1.0;
        while (mark <= 1.0) {
            marks.push({ value: mark, label: mark.toString() })
            mark = Math.round((mark + 0.1) * 10) / 10
        }
        return marks
    }

    const getRenderedOption = (option: analyseAnfrage): ReactElement => {
        const start = new Date(option.start).toLocaleDateString();
        const ende = new Date(option.ende).toLocaleDateString();
        return <small>
            <b>{option.name}</b><br />
            {start} - {ende}<br />
            {option.korrelationsergebnistyp == CorrelationResultType.single ?
                (option.korrelationstyp == CorrelationCalculationType.betweenMessstellen ? "Korrelation zwischen Messstellen für Kenngröße " + option.kenngroessen[0] : "Korrelation zwischen Kenngrößen für Messstelle " + option.messstellen[0]) :
                "Anzahl/Anteil korrelierender " + (option.korrelationstyp == CorrelationCalculationType.betweenMessstellen ? "Kenngrößen" : "Messstellen") + " zwischen " + round4Digits(option.koeffizientMin ?? -1) + " und " + round4Digits(option.koeffizientMax ?? 1)}
        </small>
    }

    return (
        <React.Fragment>
            <Grid item md={12} style={{ marginBottom: "20px" }} />
            
            <Grid item md={12} style={{ textAlign: 'left' }}>
                <Typography color="primary">Vorberechnete Korrelationen<IconButton onClick={() => dispatch(getCalculatedKorrelationen('-1'))} aria-label="neuladen"><CachedIcon /></IconButton></Typography>
                <Autocomplete
                    id="select-calculatedKorrelationen"
                    noOptionsText={<React.Fragment>{isCalculatedKorrelationenLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Auswahl"}</React.Fragment>}
                    value={selectedCalculatedKorrelation}
                    options={calculatedKorrelationen}
                    onChange={(_, newValue) => {
                        dispatch(setSelectedCalculatedKorrelation(newValue ?? {} as analyseAnfrage));
                        dispatch(setIsChangedKorrelation(true));
                    }}
                    inputValue={calculatedKorrelationenInputvalue}
                    onInputChange={(_, nV) => setCalculatedKorrelationenInputvalue(nV)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label="Auswahl"
                            variant="outlined"
                            InputLabelProps={{ ...params.InputLabelProps }}
                            InputProps={{ ...params.InputProps }}
                        />}
                    getOptionLabel={(option) => option.name}
                    renderOption={(option) => {
                        return getRenderedOption(option);
                    }}
                    className={classes.selectEmpty}
                    style={{ marginBottom: "25px" }}
                />
                {selectedCalculatedKorrelation?.korrelationsergebnistyp == CorrelationResultType.count || selectedCalculatedKorrelation?.korrelationsergebnistyp == CorrelationResultType.percentage ?
                <FormControl component="fieldset" className={classes.fullWidth} style={{ marginBottom: "20px" }}>
                    <RadioGroup
                        row
                        value={ergebnistyp}
                        onChange={(event) => {
                            dispatch(setErgebnistyp(event.target.value as CorrelationResultType));
                            dispatch(setIsChangedKorrelation(true));
                        }}
                    >
                        <FormControlLabel value="count" control={<Radio size="small" />} label="Anzahl" className={classes.RadioButtonLabel} />
                        <FormControlLabel value="percentage" control={<Radio size="small" />} label="Anteil (in Prozent)" className={classes.RadioButtonLabel} />
                    </RadioGroup>
                </FormControl> : "" }
                {selectedCalculatedKorrelation?.id > 0 ?
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                        dispatch(setSelectedCalculatedKorrelation({} as analyseAnfrage));
                        dispatch(setIsChangedKorrelation(true));
                    }}
                >
                        Neue Korrelation berechnen lassen
                </Button> : <React.Fragment>
                    <Typography color="primary">Neue Korrelation berechnen lassen zwischen</Typography>
                    <FormControl component="fieldset" className={classes.fullWidth} style={{ marginBottom: "20px" }}>
                        <RadioGroup
                            row
                            value={korrelationZwischenTemp}
                            onChange={(event) => {
                                dispatch(setKorrelationZwischenWertTemp({ value: "", groupBy: "", id: "" }));
                                dispatch(setKorrelationZwischenTemp(event.target.value as CorrelationCalculationType));
                                dispatch(setIsChangedKorrelation(true));
                            }}
                        >
                            <FormControlLabel value="betweenKenngroessen" control={<Radio size="small" />} label="Kenngrößen" className={classes.RadioButtonLabel} />
                            <FormControlLabel value="betweenMessstellen" control={<Radio size="small" />} label="Messstellen" className={classes.RadioButtonLabel} />
                        </RadioGroup>
                    </FormControl>
                    {korrelationZwischenTemp != CorrelationCalculationType.none ?
                        <div>
                            <Typography color="primary">
                                {korrelationZwischenTemp == CorrelationCalculationType.betweenKenngroessen ? "für Messstelle *" : "für Kenngröße *"}
                            </Typography>
                            <Autocomplete
                                id="select-korrelationZwischen"
                                noOptionsText={<React.Fragment>
                                    {isListeLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Werte"}</React.Fragment>}
                                value={korrelationZwischenWertTemp}
                                options={korrelationZwischenTemp == CorrelationCalculationType.betweenKenngroessen ? messstelleListe : kenngroesseListe}
                                getOptionLabel={(option) => option.value}
                                onChange={(_, nV) => {
                                    const newValue = nV != null ? nV : {
                                        value: "",
                                        groupBy: "",
                                        id: ""
                                    };
                                    dispatch(setKorrelationZwischenWertTemp(newValue));
                                    dispatch(setIsChangedKorrelation(true));
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        label="Wertauswahl"
                                        variant="outlined"
                                        InputLabelProps={{ ...params.InputLabelProps }}
                                        InputProps={{ ...params.InputProps }}
                                    />}
                                groupBy={(option) => option.groupBy}
                                renderGroup={(params) => {
                                    return params.group != "" ?
                                        <React.Fragment>
                                            <Button style={{ fontWeight: "bold", textTransform: "none", fontSize: "medium" }}
                                                onClick={() => openGroups.includes(params.group) ?
                                                    dispatch(setOpenGroups(openGroups.filter(x => x != params.group))) :
                                                    dispatch(setOpenGroups(openGroups.concat([params.group])))}>
                                                {openGroups.includes(params.group) ? <KeyboardArrowDown style={{ marginRight: 10 }} /> : <KeyboardArrowRight style={{ marginRight: 10 }} />}{params.group}
                                            </Button>{
                                                openGroups.includes(params.group) ? params.children : ""}
                                            <br />
                                        </React.Fragment> : params.children
                                }
                                }
                                className={classes.selectEmpty}
                                style={{ marginBottom: "25px" }}
                            />
                            {korrelationZwischenWertTemp.value == "Alle" ? 
                            <React.Fragment>
                                <Typography color="primary">
                                    Korrelationskoeffizient
                                </Typography>
                                <Slider
                                    value={[...sliderTemp]}
                                    step={0.1}
                                    marks={marks}
                                    min={-1.0}
                                    max={1.0}
                                    valueLabelDisplay="auto"
                                    aria-labelledby="range-slider"

                                    onChange={(_, nV) => {
                                        dispatch(setSliderTemp(nV as number[]));
                                    }}
                                    onChangeCommitted={(_, nV) => {
                                        dispatch(setSliderTemp(nV as number[]));
                                        dispatch(setIsChangedKorrelation(true));
                                    }}
                                    className={classes.marks}
                                    style={{ width: "98%", marginTop: "10px", marginLeft: "10px", marginRight: "30px", marginBottom: "35px" }}
                                />
                            </React.Fragment> : ""}
                        </div> : ""}
                        </React.Fragment> }
            </Grid>
        </React.Fragment>
    );
}
